import { useSuspenseQuery } from '@tanstack/react-query'
import AppDataRepository from '~repositories/impl/app-data-repository'
import { APP_QUERY_KEYS } from './query-keys'

const useMyPets = () => {
  return useSuspenseQuery({
    queryKey: APP_QUERY_KEYS.myPets,
    queryFn: () => AppDataRepository.getMyPets(),
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    retry: 2,
    refetchOnWindowFocus: true,
  })
}

export default useMyPets
